module.exports = __webpack_public_path__ + "img/涉县铁矿.3baebda5.jpg";